import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Amplify, { Logger } from 'aws-amplify'
import awsexports from './aws-exports'

//  Using plain css
import './assets/sb-admin-2/sb-admin-2.css'

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Amplify.configure(awsexports)
Amplify.Logger.LOG_LEVEL = 'DEBUG'

const logger = new Logger('main')

logger.debug('awsexports:', awsexports)
logger.debug('process.env', process.env)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
